import React from "react";
import { PageHeader } from "./PageHeader";
import { DataBox } from "./DataBox";
import { useApplyListModel } from "../applyListModel";
import { ApplyModal } from "./details/applyModal";
import { useApplyListDetailsModel } from "./details/applyListDetailsModel";
export function ApplyAssetsList() {
    const { selectedRowKeys } = useApplyListModel();

    const { applyVisible } = useApplyListDetailsModel()
    return (
        <>
            <PageHeader />
            <DataBox />
            {applyVisible&&<ApplyModal/>}
        </>
    );
}